<template>
    <div>
        <Row>
        <i-col span="22">  
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add"  v-if="privilegesbtn('/service/create')">新增</Button>  
        </i-col>
    </Row>
    <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>

    </div>
</template>
<script>
import { serviceindex } from "../../api/serviceapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte: privilegesbtn("/service/update"),
      tableColumns: [
        {
          title: "服务代码",
          key: "code",
          align: "center"
        },

        {
          title: "服务名称",
          key: "name",
          align: "center"
        },
        {
          title: "服务logo",
          key: "logo_path",
          align: "center",
          render: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  style: "width: 40px;height: 40px;"
                }
              },
              [
                h("img", {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  attrs: {
                    src: params.row.logo_path,
                    style: "width: 40px;height: 40px;border-radius: 2px;"
                  },
                  style: {}
                })
              ]
            );
          }
        },
        {
          title: "客房可用",
          key: "room",
          align: "center",
          render: (h, params) => {
            var rel = params.row.room == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "餐饮可用",
          key: "food",
          align: "center",
          render: (h, params) => {
            var rel = params.row.food == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "线上支付",
          key: "money",
          align: "center",
          render: (h, params) => {
            var rel = params.row.money == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
           {
          title: "确认响应",
          key: "confirm",
          align: "center",
          render: (h, params) => {
            var rel = params.row.confirm == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "服务默认配置",
          key: "config",
          align: "center"
        },
        {
          title: "是否可用",
          key: "isvalid",
          align: "center",
          render: (h, params) => {
            var rel = params.row.isvalid == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isupdte
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn: privilegesbtn,
    mockTableData() {
      let para = {
        page: this.page,
        pagesize: this.pagesize
      };
      this.$Loading.start();
      serviceindex(para).then(res => {
        this.$Loading.finish();

        var Data = res.data;
        // this.total = Data.data.total;
        this.tableData = Data.data;
        console.log(Data.data);
      });
    },
    show(param) {
      this.$router.push({ path: "/serviceupdte", query: param });
    },
    add() {
      this.$router.push({ path: "/serviceadd" });
    },
    adminlist(param) {
      var query = { id: param };
      openpage("companyadmin", query);
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    this.mockTableData();
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/service/index.vue